import React from 'react'
import MarkdownIt from 'markdown-it'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'

import { capitalizeFirstLetter } from '../../utils/capitalizeFirstLetter'

import BorderlessButtonMessage from './Utils/BorderlessButtonMessage'
import { InfoWithCircleIcon } from '../Icons/Miscellaneous'

interface SuggestionAttachmentProps {
  suggestions:
    | Array<string>
    | Array<{
        text: string
        differentTextTosend?: string
      }>
  title?: string
  description?: string
  height?: number
  history?: boolean
  showTutorial: boolean
}

const md = new MarkdownIt({
  breaks: true,
  html: true,
  xhtmlOut: true,
  linkify: false,
  typographer: true,
  quotes: `""''`
})

const SuggestionAttachment = ({ suggestions, title, description, height, history, showTutorial }: SuggestionAttachmentProps): JSX.Element => {
  const translation = useSelector((state: RootState) => state.localeReducer.currentTranslations)
  const isRTL = useSelector((state: RootState) => state.localeReducer.isRTL)
  const configuration = useSelector((state: RootState) => state.retorikReducer.configuration)
  const themeColors = useSelector((state: RootState) => state.viewReducer.themeColors)

  const processedDescription = (() => {
    try {
      return md.render(description || '')
    } catch (e) {
      return description || ''
    }
  })()

  const onTutorialClick = (): void => {
    // TODO
    console.log('show tutorial')
  }

  return (
    <div
      className={`rf-w-full large:rf-p-[25px] rf-p-4 rf-flex rf-flex-col rf-items-center rf-gap-2 ${
        title || description ? 'rf-justify-between' : 'rf-justify-around'
      } rf-min-h-inherit rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-overflow-y-scroll rf-scrollbar-thin ${history && 'rf-pointer-events-none'} `}
      style={{
        height: height,
        touchAction: 'pan-y'
      }}
    >
      {/* Title if present */}
      {title && (
        // Title on the left if there is a description, middle otherwise
        <div className={`rf-w-full ${description ? '' : 'rf-text-bannerlorcenter'} rf-title-size-auto ${configuration.isUsedOnBorne ? 'rf-truncate' : 'rf-line-clamp-2'}`}>
          {capitalizeFirstLetter(title)}
        </div>
      )}

      {/* Description if present */}
      {description && (
        <div
          className='rf-w-full'
          dangerouslySetInnerHTML={{
            __html: capitalizeFirstLetter(processedDescription)
          }}
        />
      )}

      {/* Links */}
      {suggestions?.map((data, key) => {
        const text = typeof data === 'string' ? data : data.text
        const differentTextTosend = typeof data === 'string' ? undefined : data.differentTextToSend || data.text

        return (
          <React.Fragment key={key}>
            <BorderlessButtonMessage text={text} differentTextTosend={differentTextTosend} />
          </React.Fragment>
        )
      })}
      {showTutorial && (
        <div className='rf-w-full rf-flex rf-items-end rf-italic'>
          <InfoWithCircleIcon className={`${isRTL ? 'rf-pl-2' : 'rf-pr-2'} rf-h-6`} color={themeColors.card.button.text.default} />
          {`${translation.common.needhelp} ${translation.suggestion.consult}`}
          <span className={`${isRTL ? 'rf-pr-1' : 'rf-pl-1'} rf-underline rf-cursor-pointer`} onClick={onTutorialClick}>
            {translation.suggestion.thetutorial}
          </span>
        </div>
      )}
    </div>
  )
}

export default SuggestionAttachment
